import React from 'react';
import { Route, Redirect, withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';
import { Translate } from 'react-redux-i18n';
import Icon from '@material-ui/core/Icon';
import Grid from '@material-ui/core/Grid';
import Paper from '@material-ui/core/Paper';
import { hasAccess as hasRole, doesRequireSetup } from './util';

const ProtectedRoute = (receivedProps) => {
  const { component: Component, roles, ...props } = receivedProps;
  const { history } = props;
  const pathname = history.location.pathname || '';
  const search = history.location.search || '';

  if (doesRequireSetup()) {
    return <Redirect to="/fistTimeSetup" />;
  }

  if (pathname === '/player' && search.includes('mediaId')) {
    const locationSearch = {
      location: {
        pathname,
        search,
      },
    };

    localStorage.setItem('locationSearch', JSON.stringify(locationSearch));

    return <Redirect to="/player" />;
  }

  if (hasRole(roles)) {
    return <Route {...props} render={(p) => <Component {...p} />} />;
  }

  return (
    <Grid container className="media">
      <Grid item xl={3} lg={6} md={6} sm={10} xs={10}>
        <Paper className="papercard" elevation={2}>
          <Icon className="papercard__erroricon">report</Icon>
          <Translate value="unauthorized" />
        </Paper>
      </Grid>
    </Grid>
  );
};

ProtectedRoute.propTypes = {
  history: PropTypes.shape({
    location: PropTypes.shape({
      pathname: PropTypes.string,
      search: PropTypes.string,
    }),
    push: PropTypes.func.isRequired,
  }),
};

export default withRouter(ProtectedRoute);
